import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import axios from "axios";
import InterviewScheduler from "./InterviewScheduler";
import Successwithfeedbackmodal from "../../shared/Successwithfeedbackmodal";
import FailureModal from "../../shared/FailureModal";
import { useNavigate } from "react-router-dom";
import Breadcrumb from '../../Breadcrumb';

const CandidateReview = () => {
  const { state } = useLocation()
  const candidate = state.candidate;
  const userid = candidate.userid;
  const reviewMode = state.reviewMode || false;
  const job = state.job;
  const returnToModal = state.returnToModal;
  const cachedCandidates = state.cachedCandidates;
  const selected = candidate.status === "selected";
  const navigate = useNavigate();
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [selectLoading, setSelectLoading] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [message, setMessage] = useState("");
  const cvUrl = `${process.env.REACT_APP_API_URL}uploads/cvs/${candidate.uploadCV}`


  const selectCandidate = async () => {
    try {
      setSelectLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}job_application/select-candidate`, {
        userId: userid,
        jobId: job.job_id
      })
      if (response.status === 200) {
        setMessage("Candidate is Selected !")
        setShowSuccessModal(true)
        return
      }
      setShowFailureModal(true)
    } catch (error) {
      setShowFailureModal(true)
      setSelectLoading(false);
    } finally {
      setSelectLoading(false);
    }
  }

  const unselectCandidate = async () => {
    try {
      setSelectLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_API_URL}job_application/unselect-candidate`, {
        userId: userid,
        jobId: job.job_id
      });
      if (response.status === 200) {
        setMessage("Candidate is UnSelected !")
        setShowSuccessModal(true)
        return
      }
      setShowFailureModal(true)
    }
    catch (error) {
      setShowFailureModal(true)
      setSelectLoading(false);
    }
    finally {
      setSelectLoading(false);
    }
  }

  const handleBackClick = () => {
    if (returnToModal && job) {
      navigate('/manage-candidates', {
        state: {
          returnFromReview: true,
          jobData: job,
          cachedCandidates: cachedCandidates
        }
      });
    } else {
      navigate(-1);
    }
  };

  function stripHtmlTags(text) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    return doc.body.textContent || "";
  }


  return (<>
    <Breadcrumb
      title="Candidate Details"
      path={[
        { label: "Home", href: "/", active: false },
        { label: "Candidate", active: true }
      ]}
    />
    <main className="main">
      <div className="candidate-single py-120">
        <div className="container">
          <div className="candidate-single-wrapper">
            <div className="row">
              <div className="col-lg-4 mb-5">
                <div className="job-sidebar">
                  <div className="candidate-list job-single-list">
                    <h4 className="mb-4">Overview</h4>
                    <ul>

                      {/* college */}
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-graduation-cap"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>College</h6>
                          <p>{candidate.college || "College Not Available"}</p>
                        </div>
                      </li>
                      {/* university */}
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-university"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>University</h6>
                          <p>{candidate.university || "University Not Available"}</p>
                        </div>
                      </li>
                      {/* branch */}
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-graduation-cap"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Education Level</h6>
                          <p>{candidate.branch} -  {candidate.passing_year}</p>
                        </div>
                      </li>
                      {/*  */}
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-medal"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Experience</h6>
                          <p>{candidate.yearsOfExperience ? candidate.yearsOfExperience : "Not Specified"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-sack-dollar"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Expected Salary</h6>
                          <p>{candidate.currentSalary ? candidate.currentSalary : "Not Specified"}</p>
                        </div>
                      </li>

                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-venus-mars"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Gender</h6>
                          <p>{candidate.gender === 1 ? "Female" : "Male"}</p>
                        </div>
                      </li>
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-globe"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Language</h6>
                          <p>{candidate.language}</p>
                        </div>
                      </li>
                      <li>
                        <div className="job-single-list-icon">
                          <i className="fal fa-clock"></i>
                        </div>
                        <div className="job-single-list-info">
                          <h6>Member since</h6>
                          <p>{candidate.createdon ? new Date(candidate.createdon).getFullYear() : "Not Specified"}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="candidate-social">
                    <h4>Social Link</h4>
                    <div className="candidate-social-link">
                      <a href="#"><i className="fab fa-facebook-f"></i></a>
                      {candidate.githubid && <a href={candidate.githubid} target="_blank"><i className="fab fa-github"></i></a>}
                      {candidate.linkedinid && <a href={candidate.linkedinid} target="_blank"><i className="fab fa-linkedin-in"></i></a>}
                      {candidate.portfolio && <a href={candidate.portfolio} target="_blank"><i className="fas fa-briefcase"></i></a>}
                      {candidate.portfolio && <a href={candidate.portfolio} target="_blank"><i className="fab fa-instagram text-white fa-lg"></i></a>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="candidate-single-detail">
                  <div className="candidate-heading-with-img">
                    <div className="candidate-heading">
                      <button
                        type="button"
                        className="btn p-0 border-0 bg-transparent candidate-bookmark"
                        onClick={selected ? unselectCandidate : selectCandidate}
                        disabled={selectLoading}
                        title={selected ? "Unselect Candidate" : "Select Candidate"}
                      >
                        <i className={`fe-bookmark ${selected ? 'text-danger' : 'text-primary'}`}></i>
                      </button>
                      <div className="candidate-heading-content">
                        <img
                          loading="lazy"
                          role="presentation"
                          decoding="async"
                          fetchpriority="high"
                          className="rounded-circle"
                          src={
                            candidate?.profile_url
                              ? `${process.env.REACT_APP_API_URL}${candidate.profile_url}`
                              : `${process.env.REACT_APP_API_URL}/assets/img/candidate/default.jpg`
                          }
                          alt={candidate.name}
                        />
                        <div className="candidate-heading-info">
                          <h4>{candidate.name}</h4>
                          {candidate.currentDesignation && <p> <i className="fas fa-user-tie"></i>{candidate.currentDesignation}</p>}
                          <ul className="candidate-heading-list list-unstyled">
                            <li className="d-flex align-items-center mb-2 text-secondary">
                              <i className="far fa-location-dot me-2 text-primary"></i>
                              <span>{`${candidate.city_name}, ${candidate.state_name}, ${candidate.country_name}, ${candidate.post_code}` || "Address Not Available"}</span>
                            </li>
                            {candidate.email && (
                              <li className="d-flex align-items-center mb-2 text-secondary">
                                <i className="fas fa-envelope me-2 text-primary"></i>
                                <a href={`mailto:${candidate.email}`} className="text-decoration-none text-secondary">
                                  {candidate.email}
                                </a>
                              </li>
                            )}
                            {candidate.mobile && (
                              <li className="d-flex align-items-center mb-2 text-secondary">
                                <i className="fas fa-phone me-2 text-primary"></i>
                                <a href={`tel:${candidate.mobile}`} className="text-decoration-none text-secondary">
                                  {candidate.mobile}
                                </a>
                              </li>
                            )}
                          </ul>
                        </div>
                      </div>
                      <a className="btn btn-primary theme-btn d-flex align-items-center justify-content-center px-4 py-2 rounded-3 shadow-sm" href={cvUrl} target="_blank" rel="noopener noreferrer">
                        <span className="fe-download me-2"></span>
                        <span className="text-nowrap">View CV</span>
                      </a>
                    </div>
                  </div>
                  <div className="mt-5">
                    <h4 className="mb-3">About Me</h4>
                    <p className="mb-3">{stripHtmlTags(candidate.bio)}</p>
                  </div>
                  <div className="candidate-single-skill mt-5">
                    <h4 className="mb-3">Professional Skills</h4>
                    <div className="candidate-skill-content">
                      {candidate.skills ? (() => {
                        let skillsArray = [];

                        if (typeof candidate.skills === "string") {
                          try {
                            const parsed = JSON.parse(candidate.skills);
                            skillsArray = Array.isArray(parsed) ? parsed : [];
                          } catch (err) {
                            return <p>Invalid skill data</p>;
                          }
                        } else if (Array.isArray(candidate.skills)) {
                          skillsArray = candidate.skills;
                        }

                        return skillsArray.length > 0 ? (
                          skillsArray.map((skill) => (
                            <span
                              key={skill.skill_id}
                              className="skill-badge m-1 cursor-pointer"
                            >
                              {skill.skill_name}
                            </span>
                          ))
                        ) : (
                          <p>No skills specified</p>
                        );
                      })() : (
                        <p>No skills specified</p>
                      )}
                    </div>
                  </div>
                </div>
                {reviewMode && <button
                  className="theme-btn mt-5"
                  onClick={() => setShowScheduleModal(true)}
                >
                  <i className="far fa-calendar me-2"></i>
                  Schedule Interview
                </button>}
                <button
                  className="theme-btn mt-5 mx-2"
                  onClick={selectCandidate}
                  disabled={selected || selectLoading}
                >
                  Select for later
                </button>

                <button
                  className="theme-btn mt-5 mx-2"
                  onClick={unselectCandidate}
                  disabled={selectLoading}
                >
                  Unselect
                </button>
                <div className="row-cols-5 mt-5">
                  <button className="btn btn-outline-danger" onClick={handleBackClick}>Back to Candidates</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
    {reviewMode && <InterviewScheduler
      job={job}
      candidate={candidate}
      show={showScheduleModal}
      onClose={() => setShowScheduleModal(false)}
    />}
    <Successwithfeedbackmodal
      show={showSuccessModal}
      onClose={() => setShowSuccessModal(false)}
      message={message}
    />
    <FailureModal
      show={showFailureModal}
      onClose={() => setShowFailureModal(false)}
      message="Failed to select candidate"
    />

  </>);
};

export default CandidateReview;